import React from "react";
const { Card, CardOverflow, AspectRatio,  CardContent, Typography } = require("@mui/joy");

function MenuItem({ food }) {

    return (
        <Card variant="outlined" sx={{ width: 320 }}>
            <CardOverflow>
                <AspectRatio ratio="2">
                    <img
                        src={food.image}
                        loading="lazy"
                        alt=""
                    />
                </AspectRatio>
            </CardOverflow>
            {food.allergies.length >0 && (
                <CardContent>
                    <Typography level="title-sm">
                        Allergies: {food.allergies.join(", ")}
                    </Typography>
                </CardContent>
            )}
            <CardContent>
                <Typography level="title-md">
                    {food.name}
                </Typography>
                <Typography level="body-sm">
                    {food.description}
                </Typography>
            </CardContent>
        </Card>
    )
}

export default MenuItem